<template>
  <div v-if="packages.length || productGroups.length" class="order-package-widget">
    <div class="store-info">
      <span>{{ detail && detail.role && detail.role.name ? detail.role.name : '' }}</span>
    </div>

    <section v-if="packages.length" class="package-section">
      <div class="section-label">我的包裹</div>
      <order-detail-spu-list-item
        v-for="(item, index) in packages"
        :key="item.id || index"
        :item-data="item"
        :detail="detail"
      />
    </section>

    <section v-if="productGroups.length" class="package-section">
      <div class="section-label">我的商品</div>
      <div v-if="showRefundDescription" class="spu-refund-desc">
        訂單已扣除欠品與退貨品項重新計算最優惠活動
      </div>

      <div v-for="(group, index) in productGroups" :key="group.key" class="container-spu-item">
        <order-detail-spu-list-item
          v-for="(item, itemIndex) in group.orderItemList"
          :key="item.id || itemIndex"
          :item-data="item"
          :detail="detail"
          isShowPromotionTag
        />
        <div v-if="group.promotionPrice" class="promotion-price">
          <span class="label">小計：</span>
          <span>NT$ {{ group.promotionPrice }}</span>
        </div>
        <div
          v-if="group.promotion && group.promotion.title && productGroups.length >= 2 && index < productGroups.length - 1"
          class="diviser-line"
        />
      </div>
    </section>
  </div>
</template>

<script>
import orderDetailSpuListItem from "./order-detail-spu-list-item";

const createGroups = (promotionOrderItem) => {
  if (!promotionOrderItem) return [];

  const promotionGroups = (promotionOrderItem.promotionItemList || []).map((group, index) => ({
    key: `promotion-${index}`,
    promotion: group.promotion || null,
    promotionPrice: group.promotionPrice,
    orderItemList: (group.orderItemList || []).filter((item) => Number(item.type) === 0),
  }));
  const otherGroups = (promotionOrderItem.otherItemList || []).map((item, index) => ({
    key: `other-${index}`,
    promotion: null,
    promotionPrice: "",
    orderItemList: Number(item.type) === 0 ? [item] : [],
  }));

  return promotionGroups.concat(otherGroups).filter((group) => group.orderItemList.length);
};

const getItems = (promotionOrderItem) => {
  if (!promotionOrderItem) return [];
  const promotionItems = (promotionOrderItem.promotionItemList || []).reduce(
    (items, group) => {
      group.orderItemList.forEach((item) => {
        item.promotion = group.promotion || null;
      });
      return items.concat(group.orderItemList || [])
    },
    []
  );
  return promotionItems.concat(promotionOrderItem.otherItemList || []);
};

export default {
  name: "order-package-widget",
  components: { orderDetailSpuListItem },
  props: {
    detail: { type: Object, default: () => ({}) },
    itemListKey: { type: String, default: "" },
  },
  computed: {
    selectedPromotionOrderItem() {
      const key = this.itemListKey === "refundSpu" ? "refundPromotionOrderItem" : "promotionOrderItem";
      return this.detail && this.detail[key];
    },
    selectedItems() {
      const items = getItems(this.selectedPromotionOrderItem);
      return items.length ? items : ((this.detail && this.detail.orderItemList) || []);
    },
    packages() {
      return this.selectedItems.filter((item) => Number(item.type) === 1);
    },
    productGroups() {
      const groups = createGroups(this.selectedPromotionOrderItem);
      if (groups.length) return groups;

      let list = this.selectedItems
        .filter((item) => Number(item.type) === 0)
        .map((item, index) => ({
          key: `order-item-${index}`,
          promotion: null,
          promotionPrice: "",
          orderItemList: [item],
        }));
        return list
    },
    showRefundDescription() {
      return this.itemListKey === "refundSpu" && Number(this.detail && this.detail.userRefund) > 0;
    },
  },
};
</script>

<style lang="less" scoped>
.store-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f3f3f3;
  color: #323232;
  font-weight: bold;
}
.package-section { margin-bottom: 15px; }
.section-label { margin: 0 -15px 10px; padding: 8px 10px; background: #f1faff; color: #909090; font-size: 14px; }
.spu-refund-desc { margin: 0 0 20px; padding: 4px 10px; border-radius: 4px; background-color: #ffd3b2; color: #909090; font-size: 12px; }
.container-spu-item { margin-bottom: 15px; }
.diviser-line { width: 100%; height: 2px; margin-top: 10px; background-color: #e3e3e3; }
.promotion-price { padding: 10px 0; text-align: right; }
.promotion-price span { color: #909090; font-size: 18px; font-weight: bold; }
</style>
